import axios from "axios";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const get = (path) => axios.get(`${API}${path}`).then((r) => r.data);

export const post = (path, body) => axios.post(`${API}${path}`, body);
